module.exports = __webpack_public_path__ + "static/media/hualian_pic7.c051cda0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/hualian_pic7.jpg
 ** module id = 450
 ** module chunks = 0
 **/